import React from 'react';

const AdminSection = (props) => {
    return (
        <div style={{
            'height': props.height,
            'boxShadow': 'rgb(0 0 0 / 49%) 0px 5px 7px 0px',
            'borderRadius': '5px',
             // 'overflow-y':'scroll',
            // 'border':'1px solid #000'
          'padding':'10px'

        }} className={props.className} >
            {props.children}
        </div>
    );
};

export default AdminSection;
